import { print } from "graphql";
import { BaseAPI } from "@/api/base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { map, catchError } from "rxjs/operators";
import moment from "moment";
import { CarteiraMacroRegiao } from "@/models/carteiraMacroRegiao";
import GlobalStore from "@/store/modules/global";
import { throwError } from "rxjs";

const carteira = require("@/query/carteira-macro-regiao/Carteira.graphql");

export class CarteiraMacroRegiaoAPI extends BaseAPI<CarteiraMacroRegiao> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/carteiras`;
  }

  public login(
    identidade: string,
    dataNascimento: string,
    recaptcha: string
  ): AxiosObservable<CarteiraMacroRegiao[]> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(carteira),
        variables: {
          inputCarteiraMacroRegiao: { identidade, dataNascimento, recaptcha }
        }
      })
      .pipe(
        catchError(error => {
          GlobalStore.setSnackBar({
            message: error.exception.message,
            show: true,
            type: "error"
          });
          return throwError(error);
        })
      )
      .pipe(
        map((data: any) => {
          const { carteiras } = data;
          return carteiras;
        })
      );
  }
}
